import { Calibration, CalibrationAuditFilter, CalibrationFilter } from '../model/calibration';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { CalibrationReportFilter } from '../model/attachment';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { QueryParam, ServiceUtil } from '../utils/serviceUtils';

@Injectable()
export class CalibrationPatternService {

    constructor(private http: HttpClient) {
    }

    findAllById(id: number): Observable<any> {
        const url = `api/particles/pattern/${id}`;
        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }


}
